import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import TipoListaCestNcmService from "./tipoListaCestNcmService"
import FormList from 'base/FormList'

export default function TipoListaCestNcmList() {

    const [service] = useState(() => new TipoListaCestNcmService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_tlcn',
        dsName: 'descricao_tlcn',
        mainField: { name: 'descricao_tlcn', label: 'Descrição' },
        advFields: [
            { name: 'codigo_tlcn', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_tlcn', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_tlcn" sortable header="Código"></Column>
            <Column field="descricao_tlcn" sortable header="Descrição"></Column>
        </FormList >
    )
}

